import { createSelector } from "reselect";

import getBrowserVersionFloat from "selectors/device/getBrowserVersionFloat";
import getIsChrome from "selectors/device/getIsChrome";
import getIsiOS from "selectors/device/getIsMobileSafari";
import getIsOldAndroid from "selectors/device/getIsOldAndroid";

export default createSelector(
  [getBrowserVersionFloat, getIsChrome, getIsiOS, getIsOldAndroid],
  (browserVersionFloat, isChrome, isiOS, isOldAndroid) => {
    if (isiOS) {
      return false;
    }
    if (
      browserVersionFloat &&
      isChrome &&
      browserVersionFloat >= 23 &&
      !isOldAndroid
    ) {
      // Chrome 23+
      return true;
    }

    return false;
  },
);

/*
// Per http://stackoverflow.com/questions/22292224/which-web-browsers-support-the-mpeg-dash-streaming-protocol:
//
// Chrome 23
// IE 11
// Safari 8.0 (OS X Yosemite, not on iOS) NOTE: Not seeing this work, disabled.
// Firefox 22 and 23 had some native support (using only WebM codecs) it had to be enabled manually with about:config.
// Firefox 31 and newer have partial dash.js support with WebM only when media.mediasource.enabled is set in about:config. See Bugzila #778617
// DASH notably depends on MP4 support (which on Firefox for Mac has only been added in 34: Bugzilla #941296) but MP4 is not yet available to MSE as of 35, in the nightlies however there is a new setting media.mediasource.mp4.enabled.
// Also see The state of Media Source Extensions in Firefox
// Opera 20, only WebM, no h.264 yet (as of 26)

if (DEVELOPMENT) {
    if (options.forceDash) {
        return true;
    } else if (options.forceHLS) {
        return false;
    }
}

let result = false;


if (isChrome && browserVersionFloat >= 23 && !isOldAndroid) {
    // Chrome 23+
    result = true;
} else if (isEdge) {
    result = true;
} else if (isIE && browserVersionFloat >= 11 && !isWindows7) {
    // IE11+
    result = true;
} else if (isFirefox && browserVersionFloat >= 42) {
    result = true;
}

return result;
 */
